function mapValues (source, fn) {
  var destination = {}

  for (var key in source) {
    if (source.hasOwnProperty(key)) {
      destination[key] = fn(source[key])
    }
  }

  return destination
}

module.exports = mapValues



//////////////////
// WEBPACK FOOTER
// ../~/react-faux-dom/lib/utils/mapValues.js
// module id = 767
// module chunks = 0